function validateEmail(email) {
  if (!email) { return false; }
  const re = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]+$/;
  return re.test(email);
}

export default {
  validate: validateEmail,
};
